import { useOutletContext } from 'react-router';

import type { RuleBuilderTarget } from './rule-builder-modal';

export type CaptionPrefill = {
  collectionId?: string;
  caption?: string;
  title?: string;
  /** The slide or scene it's copied from, so that part can show it's saved. */
  source?: CaptionSource;
};

/** A carousel's slide, or a reel's scene, a caption is copied from. */
export type CaptionSource =
  | { assetId: string; slide: number; scene?: undefined }
  | { assetId: string; scene: number; slide?: undefined };

export type MediaOutlet = {
  /** Open the "New collection" dialog. */
  newCollection: () => void;
  /** Open the smart collection builder: new (maybe prefilled), or an existing one's rules. */
  editSmartCollection: (target?: RuleBuilderTarget) => void;
  /** Open "New caption", optionally into a collection or prefilled (e.g. a slide's text). */
  newCaption: (prefill?: CaptionPrefill) => void;
  /** Open "Add from link" (save a competitor reel), optionally into a collection. */
  addFromLink: (collectionId?: string) => void;
  /** Open the system file picker to upload, optionally into a collection. */
  pickFiles: (collectionId?: string) => void;
  /** The Library panel is hidden: pages show a button to bring it back. */
  panelHidden: boolean;
  showPanel: () => void;
};

export const useMediaOutlet = () => useOutletContext<MediaOutlet>();
